import { RouteNameEnum } from '@/router/RouteName';
import { logGuard } from '@/router/helpers';
import { User } from '@/models/User';
const userRole = (role, user) => {
    return !!role && !!user.roles && user.roles.some((userRole) => userRole && userRole.id === role);
};
export const globalUserMiddleware = async (to, _from) => {
    logGuard('[GLOBAL_USER_MIDDLEWARE]');
    const user = User.currentAuth();
    return user && user.isGlobalUser ? true : { name: RouteNameEnum.HOME };
};
